export const formatCompanyValues = ({ selectedCompany, ccnValues, ccnHasAgreement, historyValues }) => ({
  company: {
    name: selectedCompany.name,
    siret: selectedCompany.siret,
    siren: selectedCompany.siren,
    legalForm: selectedCompany.legalForm,
    addresses: [{
      department: selectedCompany.addresses[0].department,
      city: selectedCompany.addresses[0].city,
      zipCode: selectedCompany.addresses[0].zipCode,
      fields: selectedCompany.addresses[0].fields[0]
    }],
    history: historyValues || {},
    ccnHasAgreement,
    ...ccnValues
  }
});
